export enum MapProvider {
  Baidu = 'baidu',
  Google = 'google',
  Amap = 'amap'
}

// 位置坐标类型
export interface Location {
    lng: number;
    lat: number;
    accuracy?: number;
    timestamp?: number;
  }
  
  // 地图定位选项类型
  export interface MapWatchOptions {
    enableHighAccuracy?: boolean;
    timeout?: number;
    maximumAge?: number;
  }
  
  // MapView 组件属性类型
  export interface MapProps extends React.HTMLAttributes<HTMLDivElement> {
    provider?: MapProvider;
    center?: Location;
    zoom?: number;
    style?: React.CSSProperties;
    onDeviceLocationUpdate?: (location: Location) => void;
    onLocationError?: (error: any) => void;
    watchPosition?: boolean;
    watchOptions?: MapWatchOptions;
    onCenterChange?: (location: Location) => void;
  }